import { Flex } from '@mantine/core';
import cn from 'classnames';
import * as React from 'react';

import s from './DrawerLayout.module.scss';

type Props = React.PropsWithChildren<{
  actions: React.ReactNode;
  className?: string;
}>;

const DrawerLayout: React.FC<Props> = ({ actions, children, className }) => {
  return (
    <Flex direction="column" className={cn(s.root, className)}>
      {children}
      <Flex justify="flex-end" className={s.root__actions}>
        {actions}
      </Flex>
    </Flex>
  );
};

export default DrawerLayout;
